<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { mainMenu } from '../../../stores/store';
    import WarehouseList from './AccountList.svelte';
    import { currentMainFilter } from '../../../stores/filter';
    import FilterWarehouses from '../Filter/FilterWarehouses.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import AccountList from './AccountList.svelte';
    import { AccountApp } from './AccountApp';
    import { api, customerSettings } from '../../../stores/api';
    import { Account } from './Account';
    import { defaultAccount } from './defaultAccount';
    import FilterAccounts from '../Filter/FilterAccounts.svelte';
    import { get } from 'svelte/store';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import SwitchBar from '../../shared/SwitchBar/SwitchBar.svelte';
    import { SwitchBarApp } from '../../shared/SwitchBar/SwitchBarApp';

    let addMode = false;
    let showFilter: boolean = true;
    let ap: AccountApp = new AccountApp(false);
    let account: Account | null = null;

    onMount(() => {
        if (!$customerSettings.admin) {
            throw new Error('Access denied - check your permissions');
        }
        // $mainMenu.currentPage = 'PageAccounts';
        ap.prepareData(get(api)).then(() => {
            ap = ap;
        });
    });

    let switchBarApp: SwitchBarApp = new SwitchBarApp()
        .setItems([
            { id: 'all', label: 'Wszystkie konta' },
            { id: 'standard', label: 'Standardowe' },
            { id: 'technical', label: 'Techniczne' },
        ])
        .selectItem('standard');
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                {$_('Customers')}
            </div>
            <div slot="main-search">
            </div>
            <div slot="main-buttons">
                <ButtonAddSomething
                    text={$_('Add account')}
                    on:click={() => {
                        addMode = !addMode;
                        if (addMode) {
                            account = new Account().set({ ...defaultAccount }, null);
                        } else {
                            account = null;
                        }
                    }}
                />
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        {#if !addMode && showFilter}
            <div style="display: flex; flex-direction: row; align-items: center; font-size:12px; margin: 0 2px;">
                <FilterAccounts />
                <SwitchBar
                    bind:switchBarApp
                    onChange={id => {
                            switchBarApp = switchBarApp;
                        }}
                />
            </div>
        {/if}
        <div
            style="margin: 20px 0; overflow-y: auto; flex: 1; display: flex; flex-direction: column;"
        >
            {#if ap.isLoaded()}
                <AccountList bind:showFilter bind:addMode bind:ap {account} {switchBarApp} />
            {:else}
                <Spinner />
            {/if}
        </div>
    </div>
</TemplateStandard>
